import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { MFATypes, MultiFactor } from '@projects/agent/src/app/models/userprofile';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private httpClient: HttpClient, private authService: AuthenticationService) {}

  changePassword(oldPassword: string, password: string, newPassword: string) {
    const user = this.authService.getUser();

    const url = `/user/changepassword`;
    return this.httpClient.put(url, {
      Id: user.Id,
      Password: password,
      NewPassword: newPassword,
      OldPassword: oldPassword,
    });
  }

  updateTwoFactorStatus(userId: string, type: MFATypes, status: boolean, isAdmin: boolean=false) {
    const url = `/user/updatetwofactorstatus`;
    return this.httpClient.put(url, {
      Id: userId,
      Status: status,
      Type: type,
      isAdmin:isAdmin
    });
  }
}
